import React from 'react';

const Heading = ({ name }) => {
  return (
    <div className="flex py-10 text-3xl md:text-[52px]  text-[#A81414]">
      <h2>{name}</h2>
    </div>
  );
}

export default Heading;
